<template>
	<v-expansion-panels v-model="panel" flat accordion>
		<ExpansionPanel :title="'Basics'">
			<SettingSwitch
				:title="'Label'"
				:placeholder="'Type your title here'"
				:switchValue.sync="titleEnabled"
				:textFieldValue.sync="titleValue"
			/>
			<SettingSwitch :title="'Required'" :switchValue.sync="requiredEnabled" />
			<SettingSwitch :title="'Multiple files'" :switchValue.sync="isMultipleFileSelection" />
		</ExpansionPanel>
		<ExpansionPanel :title="'Explanations'">
			<SettingSwitch
				:title="'Description'"
				:placeholder="'Type your description here'"
				:switchValue.sync="descriptionEnabled"
				:textFieldValue.sync="descriptionValue"
			/>
		</ExpansionPanel>
	</v-expansion-panels>
</template>

<script>
import SettingSwitch from './WidgetSettings/SettingSwitch';
import ExpansionPanel from './WidgetSettings/ExpansionPanel';
import FieldSettingsMixin from '@/components/BlockEditorWidget/FieldSettings/FieldSettingsMixin';

export default {
	name: 'FileInputFieldSettings',
	mixins: [FieldSettingsMixin],
	components: { SettingSwitch, ExpansionPanel },
	computed: {
		isMultipleFileSelection: {
			get() {
				return this.localField.metadata.options.user_selection.multiple;
			},
			set(value) {
				this.setLocalFieldKey('metadata.options.user_selection.multiple', value);
			},
		},
	},
};
</script>
